import React, { useState } from 'react'
import styled from 'styled-components'
import { MenuRounded } from '@material-ui/icons';
import { Clear } from '@material-ui/icons';
import { selectCars } from '../features/car/carSlice';
import { useSelector } from 'react-redux';

function Header() {

    const [burgerStatus, setBurgerStatus] = useState(false)
    const cars = useSelector(selectCars);
    return (
        <Container>
            <a>
                <img src="/images/logo.svg" alt="tesla" />
            </a>

            <Menu>
                {cars && cars.map((car, index) => (
                    <a key={index} href="#">{car}</a>
                ))}
                {/* <a href="#">Model S</a>
                <a href="#">Model 3</a>
                <a href="#">Model X</a>
                <a href="#">Model Y</a> */}
            </Menu>
            <RightMenu>
                <a href="#">Shop</a>
                <a href="#">Account</a>
            </RightMenu>

            <CustomMenu onClick={() => setBurgerStatus(true)} />

            <BurgerNav show={burgerStatus}>
                <CloseWrapper>
                    <CustomClear onClick={() => setBurgerStatus(false)} />
                </CloseWrapper>
                {cars && cars.map((car, index) => (
                    <li key={index} ><a href="#">{car}</a></li>
                ))}
                <li><a href="#">Existing Inventory</a></li>
                <li><a href="#">Used Inventory</a></li>
                <li><a href="#">Trade-In</a></li>
                <li><a href="#">CyberTruck</a></li>
                <li><a href="#">Roadstar</a></li>
                <li><a href="#">Auto</a></li>
                <li><a href="#">Setting</a></li>
                <li><a href="#">Help</a></li>
            </BurgerNav>
        </Container>
    )
}

export default Header

const Container = styled.div`
 min-height:60px;
 position: fixed;
 display:flex;
 justify-content: space-between;
 align-items: center;
 padding: 0 20px;
 top:0;
 right:0;
 left:0;
 z-index:1;
`

const Menu = styled.div`
display:flex;
align-items;center;
justify-content:center;
flex:1;

a{
    font-weight:600;
    text-transform: uppercase;
    padding: 0 10px;
    flex-wrap: nowrap;

   
}
@media(max-width:768px){
    display:none;
}

`

const RightMenu = styled.div`
a{
    font-weight:600;
    text-transform: uppercase;
    margin-right:10px;
}
`

const CustomMenu = styled(MenuRounded)`
cursor:pointer;
`

const BurgerNav = styled.div`
position:fixed;
top:0;
right:0;
bottom:0;
background: white;
width:300px;
z-index:16;
list-style: none;
padding:20px;
display:flex;
flex-direction: column;
text-align:start;
transition: transform 0.6s ease-in-out;
transform: ${props => props.show ? 'translateX(0)' : 'translateX(100%)'};

li{
    padding:15px 0;
    border-bottom:1px solid rgba(0,0,0,.2);
}
a{
    font-weight:600;
    transition: all 0.7s ease-in-out;
    &:hover{
        color:red;
        cursor:pointer;
        text-decoration:underline;
    }
}

`

const CustomClear = styled(Clear)`
cursor:pointer;
`
const CloseWrapper = styled.div`
display:flex;
justify-content: flex-end;
`